module.exports = __webpack_public_path__ + "img/icon-flag-de.e88d8860.svg";